import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    DateField,
    BooleanField,
    CreateButton,
    EditButton,
    CardActions,
    useListContext
} from 'react-admin';
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";


const InstructionActions = ({
                                       bulkActions,
                                       basePath,
                                       currentSort,
                                       displayedFilters,
                                       exporter,
                                       filters,
                                       filterValues,
                                       onUnselectItems,
                                       resource,
                                       selectedIds,
                                       showFilter,
                                       total
                                   }) => (
    <CardActions>
        {bulkActions && React.cloneElement(bulkActions, {
            basePath,
            filterValues,
            resource,
            selectedIds,
            onUnselectItems,
        })}
        {filters && React.cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: 'button',
        }) }
        <CreateButton basePath={basePath} label={"Додати"} />
    </CardActions>
);

const Empty = () => {
    const { basePath } = useListContext();
    return (
        <Box textAlign="center" m={1}>
            <Typography variant="h4" paragraph>
                Інструкції - відсутні
            </Typography>
        </Box>
    );
};

export const InstructionList = (props) => (
    <List {...props}
          empty={<Empty />}
          bulkActionButtons={false}
          className="list-styles"
          perPage={25}
          title="Інструкції"
          actions={<InstructionActions/>}
    >
        <Datagrid>
            <TextField sortable={false} label="Заголовок" source="title" />
            <TextField sortable={false} label="Аліас" source="alias" />
            <DateField sortable={false} label="Дата" source="createdAt" locales={'ru'}/>
            <BooleanField source={"active"} label={'Активна'} />
            <EditButton label={"Редагувати"} />
        </Datagrid>
    </List>
);

export default InstructionList;
